var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWindowsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #000000;\n      }\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "WindowsIconplant") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M128,128l-68.13-9.59V68.3H128Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M128,59.71H59.78V58.53q0-23.72,0-47.43c0-1,.3-1.27,1.25-1.41,10.14-1.44,20.27-2.94,30.4-4.41L126.68.18,128,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M51.17,117.34l-6.85-.94L25,113.76,7.66,111.37c-2.28-.32-4.57-.64-6.85-.92-.61-.07-.81-.31-.81-.94q0-20.34,0-40.7c0-.14,0-.28.05-.49h51.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M51.18,11.15V59.7H.1V18.09Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindowsIcon);
export default __webpack_public_path__ + "static/media/WindowsIcon.0fd097eabcc58af240530c0f59ccfa78.svg";
export { ForwardRef as ReactComponent };